import api from '../services/axios.service';
import { constructQueryParams } from '../utils/utils';

export async function fetchPipelines(page = 0, pageSize = 10, searchQuery = null, tagIds = null, tag_filter_operation = 'or') {
    const queryParams = constructQueryParams({ page, page_size: pageSize, partial_name: searchQuery, tag_ids: tagIds, tag_filter_operation });

    return api.get(`pipelines?${queryParams}`);
}

export async function fetchAllPipelineBrief() {
    return api.get(`pipelines/brief`);
}

export async function createPipeline(connection) {
    return api.post(`pipelines`, { ...connection, created_from: 'web' });
}

export async function getPipeline(id) {
    const response = await api.get(`pipelines/${id}`);

    return response?.result?.[0];
}

export async function editPipeline(connection, id) {
    return api.put(`pipelines/${id}`, connection);
}

export async function deletePipeline(id) {
    return api.delete(`pipelines/${id}`);
}

export async function bulkUpdatePipelinesWithTags(ids = [], all = false, tags = []) {
    return api.put(`pipelines/bulk_update`, { ids, update_all: all, payload: { tags } });
}
